module.exports = __webpack_public_path__ + "static/media/qualmet-logo-new-white.050d67e5.png";